import { Button } from "@/shared/components/ui/button"
import { Menu, X } from "lucide-react"
import { useState } from "react"
import { Link } from "react-router-dom"

export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/80 backdrop-blur-md border-b border-border">
      <nav className="container mx-auto px-4 lg:px-8">
        <div className="flex items-center justify-between h-16 lg:h-20">
          <Link to="/" className="flex items-center">
            <img src="/images/logo-rapyfact.png" alt="Rapyfact" className="h-8 lg:h-10 w-auto" />
          </Link>

          <div className="hidden md:flex items-center gap-6 lg:gap-8">
            <Link to="/" className="text-lg font-medium hover:text-primary transition-colors">
              Inicio
            </Link>
            <a
  href="https://app.rapyfact.com/app/plans"
  target="_blank"
  rel="noopener noreferrer"
  className="text-lg font-medium hover:text-primary transition-colors"
>
  Elige Tu Plan
</a>

            {/*<Link to="/contacto" className="text-lg font-medium hover:text-primary transition-colors">
              Contáctenos
            </Link>*/}
            <Link to="/servicios" className="text-lg font-medium hover:text-primary transition-colors">
              Servicios
            </Link>
            <Link to="/sobre-nosotros" className="text-lg font-medium hover:text-primary transition-colors">
              Sobre nosotros
            </Link>
            
          </div>

          <div className="hidden md:block">
            <a
              href="https://app.rapyfact.com/register"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Button className="bg-primary hover:bg-primary/90 text-primary-foreground text-lg py-4 px-6">
                Iniciar Sesión
              </Button>
            </a>
          </div>

          <button
            className="md:hidden p-2"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle menu"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {mobileMenuOpen && (
          <div className="md:hidden py-4 border-t border-border">
            <div className="flex flex-col gap-4">
              <Link to="/" className="text-sm font-medium hover:text-primary transition-colors">
                Inicio
              </Link>
              <a
  href="https://app.rapyfact.com/app/plans"
  target="_blank"
  rel="noopener noreferrer"
  className="text-sm font-medium hover:text-primary transition-colors"
>
  Elige Tu Plan
</a>

              <Link to="/contacto" className="text-sm font-medium hover:text-primary transition-colors">
                Contáctenos
              </Link>
              <Link to="/servicios" className="text-sm font-medium hover:text-primary transition-colors">
                Servicios
              </Link>
              <Link to="/sobre-nosotros" className="text-sm font-medium hover:text-primary transition-colors">
                Sobre nosotros
              </Link>
              <Link to="/videos" className="text-sm font-medium hover:text-primary transition-colors">
                Videos
              </Link>
              <a
                href="https://app.rapyfact.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                <Button className="bg-primary hover:bg-primary/90 text-primary-foreground w-full">
                  Iniciar Sesión
                </Button>
              </a>
            </div>
          </div>
        )}
      </nav>
    </header>
  )
}
